import { render, staticRenderFns } from "./Residential.vue?vue&type=template&id=5fdc1f63"
import script from "./Residential.vue?vue&type=script&lang=js"
export * from "./Residential.vue?vue&type=script&lang=js"
import style0 from "./Residential.vue?vue&type=style&index=0&id=5fdc1f63&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports